import { backendClient } from './backend';

// backendClient.get() returns a raw Response object.
// All analytics tabs expect axios-style { data } — wrap with json parsing.
const jsonGet = async (url) => {
  const res = await backendClient.get(url);
  const data = await res.json();
  return { data };
};

export const analyticsApi = {
  // Overview
  getOverview: (period = '30d') =>
    jsonGet(`api/analytics/admin/overview?period=${period}`),

  getActiveUsers: (period = '30d', granularity = 'day') =>
    jsonGet(`api/analytics/admin/active-users?period=${period}&granularity=${granularity}`),

  getTopPages: (period = '30d', source = '', limit = 20) => {
    let url = `api/analytics/admin/top-pages?period=${period}&limit=${limit}`;
    if (source) url += `&source=${source}`;
    return jsonGet(url);
  },

  // User Tracking
  getUsers: (period = '30d', search = '', page = 1, limit = 50) => {
    let url = `api/analytics/admin/users?period=${period}&page=${page}&limit=${limit}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    return jsonGet(url);
  },

  getUserEvents: (userId, dateFrom = '', dateTo = '', limit = 200) => {
    let url = `api/analytics/admin/users/${userId}/events?limit=${limit}`;
    if (dateFrom) url += `&date_from=${dateFrom}`;
    if (dateTo) url += `&date_to=${dateTo}`;
    return jsonGet(url);
  },

  // Feature Adoption
  getFeatureUsage: (period = '30d') =>
    jsonGet(`api/analytics/admin/feature-usage?period=${period}`),

  getFeatureTrend: (feature, period = '30d') =>
    jsonGet(`api/analytics/admin/feature-trend?feature=${encodeURIComponent(feature)}&period=${period}`),

  // Funnels
  getFunnel: (period = '30d', funnelType = 'acquisition') =>
    jsonGet(`api/analytics/admin/funnel?period=${period}&funnel_type=${funnelType}`),

  // Retention
  getRetention: (period = '90d', granularity = 'week') =>
    jsonGet(`api/analytics/admin/retention?period=${period}&granularity=${granularity}`),

  // Landing Page
  getLanding: (period = '30d') =>
    jsonGet(`api/analytics/admin/landing?period=${period}`),

  // User Detail
  getUserComprehensive: (userId) =>
    jsonGet(`api/analytics/admin/users/${userId}/comprehensive`),

  getUserActivityFeed: (userId, page = 1, limit = 50) =>
    jsonGet(`api/analytics/admin/users/${userId}/activity-feed?page=${page}&limit=${limit}`),

  // Raw Events
  getEvents: ({ source, eventType, category, dateFrom, dateTo, page = 1, limit = 100 } = {}) => {
    let url = `api/analytics/admin/events?page=${page}&limit=${limit}`;
    if (source) url += `&source=${source}`;
    if (eventType) url += `&event_type=${eventType}`;
    if (category) url += `&category=${encodeURIComponent(category)}`;
    if (dateFrom) url += `&date_from=${dateFrom}`;
    if (dateTo) url += `&date_to=${dateTo}`;
    return jsonGet(url);
  },
};
